import { EnrollTypes } from '../../constants';
export const isEnrolled = enrollmentStatus => new Set(['USER', 'PORTAL', 'ORGANIZATION', 'ENROLLED_CANNOT_LEAVE']).has(enrollmentStatus);
export const isAllowedToLeaveBeta = enrollmentStatus => new Set(['USER', 'PORTAL', 'ORGANIZATION']).has(enrollmentStatus);
export const getIsOptionDisabled = (enrollmentStatus, enrollType) => {
  if (enrollmentStatus === 'PORTAL') {
    return enrollType === EnrollTypes.USERS_ONLY || enrollType === EnrollTypes.ORGANIZATIONS_ONLY;
  } else if (enrollmentStatus === 'USER') {
    return enrollType === EnrollTypes.PORTALS_ONLY || enrollType === EnrollTypes.ORGANIZATIONS_ONLY;
  } else {
    return enrollType !== EnrollTypes.ORGANIZATIONS_ONLY;
  }
};